import {
  put,
  fork,
  call,
  take,
  takeEvery,
  takeLatest,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadHappygoOrderListCompletion,
  cancelHappygoOrderCompletion,
  loadHappygoOrderCompletion,
  preCreateHappygoOrderCompletion,
  createHappygoOrderCompletion,
  payHappygoOrderByWechatCompltion,
  refundHappygoOrderCompletion,
  loadHappygoOrder,
  deleteAllHappygoProduct,
  loadHappygoOrderTrackCompletion,
  loadHappygoProductMaster,
  catchError,
} from '../../actions';

function* watchLoadHappygoOrderList() {
  yield takeLatest('LOAD_HAPPYGO_ORDER_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.happygo.order.master);
    const tabDict = { all: 0, willpay: 1, didship: 2 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    if (!query.keyword) {
      tab = tabDict[query.tab];
    }

    const options = {
      url: `/efapi/order/list?start=${start}&size=${
        query.size
      }&status=${tab}&keywords=${encodeURIComponent(query.keyword)}`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadHappygoOrderListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchCancelHappygoOrder() {
  while (true) {
    const { orderId } = yield take('CANCEL_HAPPYGO_ORDER');
    const options = {
      url: `/efapi/order/${orderId}/cancel`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(cancelHappygoOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchRefundHappygoOrder() {
  while (true) {
    const { orderId } = yield take('REFUND_HAPPYGO_ORDER');
    const options = {
      url: `/efapi/order/${orderId}/refund`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(refundHappygoOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchLoadHappygoOrder() {
  yield takeEvery('LOAD_HAPPYGO_ORDER', function*({ orderId }) {
    const options = {
      url: `/efapi/order/${orderId}/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadHappygoOrderCompletion(orderId, result.data, result.error));
  });
}

function* watchPreCreateHappygoOrder() {
  yield takeEvery('PRE_CREATE_HAPPYGO_ORDER', function*({ selectedList }) {
    const orderCreate = yield select(state => state.mall.order.create);
    const { addressId } = orderCreate;

    const options = {
      url: '/efapi/order/preCreate',
      method: 'POST',
      data: {
        skus: selectedList,
        addressId,
        warehouseId: null,
        postageCouponCode: null,
      },
    };
    const result = yield call(app.httpFetch, options);

    if (result.error) {
      const prevSelectedList = yield select(
        state => state.mall.order.create.selectedList
      );
      yield put(
        preCreateHappygoOrderCompletion(
          result.error,
          null,
          null,
          prevSelectedList
        )
      );
      return;
    }

    yield put(
      preCreateHappygoOrderCompletion(result.error, result.data, selectedList)
    );
  });
}

function* watchCreateHappygoOrder() {
  yield takeEvery('CREATE_HAPPYGO_ORDER', function*() {
    const orderCreate = yield select(state => state.happygo.order.create);
    const {
      addressId,
      warehouseId,
      selectedList,
      postageId,
      key,
    } = orderCreate;

    let error;

    if (!addressId) {
      error = new Error('请填写收货地址');
    }

    if (error) {
      yield put(catchError(error));
      yield put(createHappygoOrderCompletion(error));
      return;
    }

    const options = {
      url: '/efapi/order/create',
      method: 'POST',
      data: {
        addressId,
        warehouseId,
        skus: selectedList,
        postageCouponCode: postageId === '' ? null : postageId,
        key: encodeCreateOrderKey(key),
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(createHappygoOrderCompletion(result.error, result.data));

    if (!result.error) {
      yield put(deleteAllHappygoProduct());
      yield put(loadHappygoProductMaster());
    }
  });
}

function encodeCreateOrderKey(key) {
  return (
    key &&
    key
      .split('')
      .map((str, i) => {
        const charCode = str.charCodeAt();
        if (i <= 4) {
          if (charCode >= 54) {
            return String.fromCharCode(charCode + 19);
          }
        } else if (i > 4 && i <= 7) {
          return String.fromCharCode(charCode + 52);
        } else if (i > 7 && i <= 9) {
          if (charCode === '3') {
            return 'b';
          } else if (charCode === '8') {
            return 'm';
          }
        } else if (i > 12) {
          if (charCode <= 57) {
            return String.fromCharCode(charCode + 60);
          } else {
            return String.fromCharCode(charCode + (i % 15));
          }
        }

        return str;
      })
      .join('')
  );
}

function* watchPayHappygoOrderByWechat() {
  yield takeEvery('PAY_HAPPYGO_ORDER_BY_WECHAT', function*({ orderId }) {
    if (app.wechat) {
      try {
        yield call(app.wechat.pay, { payModule: 3, id: orderId });
        yield call(afterPayOrder, orderId);
        yield put(payHappygoOrderByWechatCompltion(orderId));
      } catch (error) {
        yield put(catchError(error));
        yield put(payHappygoOrderByWechatCompltion(orderId, error));
      }

      return;
    }

    /* MWEB */
    window.location.href = `/efapi/order/${orderId}/wxpay?redirectUrl=${encodeURIComponent(
      window.location.href
    )}`;
    yield put(
      payHappygoOrderByWechatCompltion(orderId, new Error('微信支付跳转中...'))
    );
  });
}

function* afterPayOrder(orderId) {
  yield put(loadHappygoOrder(orderId));
  yield take('LOAD_HAPPYGO_ORDER_COMPLETION');
}

function* watchLoadHappygoOrderTrack() {
  yield takeEvery('LOAD_HAPPYGO_ORDER_TRACK', function*({ expressNo }) {
    const options = {
      url: `/api/order/${expressNo}/trace`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadHappygoOrderTrackCompletion(expressNo, result.error, result.data)
    );
  });
}

export default function* orderSaga() {
  yield all([
    fork(watchLoadHappygoOrderList),
    fork(watchCancelHappygoOrder),
    fork(watchLoadHappygoOrder),
    fork(watchPreCreateHappygoOrder),
    fork(watchCreateHappygoOrder),
    fork(watchPayHappygoOrderByWechat),
    fork(watchRefundHappygoOrder),
    fork(watchLoadHappygoOrderTrack),
  ]);
}
